// Copyright (c) 2025 Audere, All Rights Reserved

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AuthState } from "../../types/auth";
import type { RootState } from "../store";

const initialState: AuthState = {
  email: "",
  name: "",
  picture: null,
  credentials: "",
  token: "",
  expires: "",
  organizationId: "",
  roles: [],
  isLoggedOut: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state: AuthState, action: PayloadAction<AuthState>) => {
      state.email = action.payload?.email;
      state.name = action.payload?.name;
      state.picture = action.payload?.picture;
      state.credentials = action.payload?.credentials;
      state.token = action.payload?.token;
      state.expires = action.payload?.expires;
      state.organizationId = action.payload.organizationId;
      state.roles = action.payload.roles;
    },
    setRolesData: (
      state: AuthState,
      action: PayloadAction<{ organizationId: string; roles: string[] }>
    ) => {
      state.organizationId = action.payload.organizationId;
      state.roles = action.payload.roles;
    },
    logOut: (state: AuthState) => {
      state.email = "";
      state.name = "";
      state.picture = null;
      state.credentials = "";
      state.token = "";
      state.expires = "";
      state.organizationId = "";
      state.roles = [];
      state.isLoggedOut = true;
    },
    resetIsLoggedOut: (state: AuthState) => {
      state.isLoggedOut = false;
    },
  },
});

export const { setCredentials, setRolesData, logOut, resetIsLoggedOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentToken = (state: RootState) => state.auth.token;
export const selectCurrentName = (state: RootState) => state.auth.name;
export const selectCurrentPicture = (state: RootState): string | null => state.auth.picture;
export const selectCurrentOrganizationId = (state: RootState): string | null =>
  state.auth.organizationId;
export const selectIsLoggedOut = (state: RootState) => state.auth.isLoggedOut;
